import { AxiosInstance } from 'axios';
import { CourseModule } from './types';

export function modulesApi(client: AxiosInstance) {
  return {
    getList: (courseId: number) =>
      client.post<{ items: CourseModule[] }>('/api/v1/admin/modules/get-list', { courseId }),
    getById: (id: number) =>
      client.post<CourseModule>('/api/v1/admin/modules/get-by-id', { id }),
    getAll: () =>
      client.post<{ items: CourseModule[] }>('/api/v1/admin/modules/get-all', {}),
    create: (data: Omit<CourseModule, 'id'>) =>
      client.post<CourseModule>('/api/v1/admin/modules/create', data),
    update: (data: CourseModule) =>
      client.post<CourseModule>('/api/v1/admin/modules/update', data),
    reorder: (courseId: number, items: { id: number; sortOrder: number }[]) =>
      client.post<{ items: CourseModule[] }>('/api/v1/admin/modules/reorder', { courseId, items }),
  };
}
